import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationNamespace } from 'i18n';
import type { PaymentField } from 'types';

import { ROSA_ONE_PALETTE } from '../../constants/rosa-one-palette.constant';
import type { RosaOneCollapseState } from '../../types';
import { RosaOneButton } from '../RosaOneButton';

type RosaOneFieldsListProps = {
  fields: PaymentField[];
  collapseState: RosaOneCollapseState;
  onToggle: () => void;
};

export const RosaOneFieldsList: React.FC<RosaOneFieldsListProps> = ({
  fields,
  collapseState,
  onToggle,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.rosa_one',
  });

  return (
    <>
      <div
        className={cx('sber-details-collapse', {
          'sber-details-collapse--open': collapseState === 'open',
          'sber-details-collapse--closing': collapseState === 'closing',
          'sber-details-collapse--closed': collapseState === 'closed',
        })}
      >
        <dl
          style={{ borderTopColor: ROSA_ONE_PALETTE.line }}
          className="tw-m-0 tw-border-t tw-border-solid"
        >
          {fields.map((field) => (
            <div
              key={field.name}
              style={{ borderBottomColor: ROSA_ONE_PALETTE.line }}
              className="tw-grid tw-grid-cols-[1fr_1.6fr] tw-gap-3 tw-py-3 tw-border-b tw-border-solid"
            >
              <dt
                style={{ color: ROSA_ONE_PALETTE.muted }}
                className="tw-m-0 tw-text-[13px]"
              >
                {field.label}
              </dt>
              <dd
                className="tw-m-0 tw-font-[650] tw-text-right tw-text-[13px]"
                style={{ color: ROSA_ONE_PALETTE.text }}
              >
                {field.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
      <RosaOneButton
        link
        onClick={onToggle}
        label={collapseState === 'open' ? t('hide_details') : t('show_details')}
        className="md:tw-hidden tw-block tw-mt-3 tw-mx-auto tw-text-xs"
      />
    </>
  );
};
